import { FmPropertyBoundarySnapshot } from "./FmPropertyBoundarySnapshot";
import {
  BROWSE_PARCEL_PUBLIC_PICTURE_SLOT_KEY,
  registerMapSlot,
} from "@/shared/config/mapSlotRegistry";

registerMapSlot(BROWSE_PARCEL_PUBLIC_PICTURE_SLOT_KEY, (slotProps) => {
  if (!slotProps.propertyId) {
    return <div data-state="empty" />;
  }
  return (
    <FmPropertyBoundarySnapshot
      propertyId={slotProps.propertyId}
      caption={slotProps.caption}
      size={slotProps.snapshotSize ?? "compact"}
      revisionKey={slotProps.sourceId}
      data-testid="browse-parcel-public-picture"
    />
  );
});
